/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">Sw2</vs-button>
          <vs-button :color="sel==='sw3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw3'">Sw3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Extended named ACL WWW_ACL on R1 e0/1</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/7</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mt-2 ml-1" style="color:#6b7280">Verify: <code>sh ip access-lists</code> on R1</p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Telnet access on Sw2 — AdminGroup, Scrypt</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                  <code class="text-base" :class="sw2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">DHCP Snooping on Sw3 — VLANs 102, 202</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Sw3</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(sw3Completion[item.key])"></div>
                  <code class="text-base" :class="sw3Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dk in ['r1','sw2','sw3']" :key="'s-'+dk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(dk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dk).saved)"></div>
                    <code class="text-base" :class="getComp(dk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'"  key="r1"  id="r1_terminal"  :commands="r1Commands"  :prompt="r1Prompt"  :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw2" />
          <vue-command v-show="sel==='sw3'" key="sw3" id="sw3_terminal" :commands="sw3Commands" :prompt="sw3Prompt" :show-intro="true" intro="Cisco IOS Software — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw3" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the checklist. Use "sh ip access-lists" on R1 to verify the ACL.';

const mkCommands = (dev, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(dev),
  configure:  (x) => vm.iosConfigure(dev, x),
  conf:       (x) => vm.iosConfigure(dev, x),
  interface:  (x) => vm.iosInterface(dev, x),
  int:        (x) => vm.iosInterface(dev, x),
  ip:         (x) => vm.iosIp(dev, x),
  permit:     (x) => vm.iosPermit(dev, x),
  deny:       (x) => vm.iosDeny(dev, x),
  username:   (x) => vm.iosUsername(dev, x),
  line:       (x) => vm.iosLine(dev, x),
  login:      (x) => vm.iosLogin(dev, x),
  transport:  (x) => vm.iosTransport(dev, x),
  show:       (x) => vm.iosShow(dev, x),
  sh:         (x) => vm.iosShow(dev, x),
  exit:       () => vm.iosExit(dev),
  end:        () => vm.iosEnd(dev),
  copy:       (x) => vm.iosCopy(dev, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      sel: 'r1',
      totalScore: 0,

      r1:  { mode: 'exec', currentIf: null },
      sw2: { mode: 'exec', currentIf: null },
      sw3: { mode: 'exec', currentIf: null },

      // r1(8) + sw2(5) + sw3(4) = 17 total
      r1Completion: {
        aclCreated: false, acePermitHttp: false, aceDenyHttp: false,
        aceDenyTelnet: false, acePermitAll: false,
        e01If: false, accessGroup: false,
        saved: false,
      },
      sw2Completion: {
        username: false, lineVty: false, transportTelnet: false, loginLocal: false,
        saved: false,
      },
      sw3Completion: {
        dhcpSnooping: false, dhcpSnoopingVlan: false, dhcpSnoopingMac: false,
        saved: false,
      },

      r1Commands: null, sw2Commands: null, sw3Commands: null,

      task1Items: [
        { key: 'aclCreated',    label: 'ip access-list extended WWW_ACL' },
        { key: 'acePermitHttp', label: 'permit tcp 10.101.1.0 0.0.0.255 any eq www' },
        { key: 'aceDenyHttp',   label: 'deny tcp any any eq www' },
        { key: 'aceDenyTelnet', label: 'deny tcp host 10.101.0.2 any eq telnet' },
        { key: 'acePermitAll',  label: 'permit ip any any' },
        { key: 'e01If',         label: 'interface e0/1' },
        { key: 'accessGroup',   label: 'ip access-group WWW_ACL in' },
      ],
      task2Items: [
        { key: 'username',        label: 'username AdminGroup privilege 15 algorithm-type scrypt secret BumBL3d' },
        { key: 'lineVty',         label: 'line vty 0 4' },
        { key: 'transportTelnet', label: 'transport input telnet' },
        { key: 'loginLocal',      label: 'login local' },
      ],
      task3Items: [
        { key: 'dhcpSnooping',     label: 'ip dhcp snooping' },
        { key: 'dhcpSnoopingVlan', label: 'ip dhcp snooping vlan 102,202' },
        { key: 'dhcpSnoopingMac',  label: 'ip dhcp snooping verify mac-address' },
      ],
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config-ext-nacl') return 'R1(config-ext-nacl)#';
      if (m === 'config-if')       return 'R1(config-if)#';
      if (m === 'config')          return 'R1(config)#';
      return 'R1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config-line') return 'Sw2(config-line)#';
      if (m === 'config')      return 'Sw2(config)#';
      return 'Sw2#';
    },
    sw3Prompt() { const m=this.sw3.mode; return m==='config'?'Sw3(config)#':'Sw3#'; },

    task1Progress() {
      const c = this.r1Completion;
      return [c.aclCreated, c.acePermitHttp, c.aceDenyHttp, c.aceDenyTelnet, c.acePermitAll, c.e01If, c.accessGroup].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 7; },

    task2Progress() {
      const c = this.sw2Completion;
      return [c.username, c.lineVty, c.transportTelnet, c.loginLocal].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 4; },

    task3Progress() {
      const c = this.sw3Completion;
      return [c.dhcpSnooping, c.dhcpSnoopingVlan, c.dhcpSnoopingMac].filter(Boolean).length;
    },
    task3Done() { return this.task3Progress === 3; },

    saveProgress() {
      return [this.r1Completion.saved, this.sw2Completion.saved, this.sw3Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress === 3; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands  = mkCommands('r1', this);
    this.sw2Commands = mkCommands('sw2', this);
    this.sw3Commands = mkCommands('sw3', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },
    devLabel(k) { return { r1:'R1', sw2:'Sw2', sw3:'Sw3' }[k] || k; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    normalizeIf(ifStr) {
      return (ifStr||'').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },
    updateScore() {
      let score = 0;
      [this.r1Completion, this.sw2Completion, this.sw3Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 17) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(dev) { this[dev].mode = 'exec'; return createStdout(''); },

    iosConfigure(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[dev].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(dev) {
      const s = this[dev];
      if (s.mode === 'config-if' || s.mode === 'config-line' || s.mode === 'config-ext-nacl') {
        s.mode = 'config'; s.currentIf = null;
      } else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },
    iosEnd(dev) { this[dev].mode = 'exec'; this[dev].currentIf = null; return createStdout(''); },

    iosInterface(dev, x) {
      const s = this[dev];
      const validModes = ['config', 'config-if'];
      if (!validModes.includes(s.mode)) return createStderr('% Must be in configuration mode');
      let ifArg = String(x._[1]||'');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) ifArg = ifArg + x._[2];
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[dev + 'Completion'];
      if (dev === 'r1' && ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(dev, x) {
      const s = this[dev];
      const sub1 = (x._[1]||'').toLowerCase();
      const sub2 = (x._[2]||'').toLowerCase();
      const sub3 = (x._[3]||'').toLowerCase();
      const c = this[dev + 'Completion'];

      // Global config commands
      if (s.mode === 'config') {
        // ip access-list extended WWW_ACL
        if (sub1 === 'access-list' && sub2 === 'extended') {
          const aclName = (x._[3]||'').toUpperCase();
          if (dev === 'r1' && aclName === 'WWW_ACL' && !c.aclCreated) {
            c.aclCreated = true; this.updateScore();
            s.mode = 'config-ext-nacl';
            return createStdout(this.guide(
              'Extended named ACL "WWW_ACL" created. Named ACLs allow editing individual entries later. → Enter ACEs in order: permit/deny statements. Mode is now R1(config-ext-nacl)#.'
            ));
          }
          if (dev === 'r1' && (x._[3]||'').toUpperCase() === 'WWW_ACL' && c.aclCreated) {
            s.mode = 'config-ext-nacl';
            return createStdout('');
          }
          return createStdout('');
        }

        // ip dhcp snooping [vlan / verify mac-address]
        if (sub1 === 'dhcp' && sub2 === 'snooping') {
          if (dev === 'sw3') {
            if (!sub3 && !c.dhcpSnooping) {
              c.dhcpSnooping = true; this.updateScore();
              return createStdout(this.guide('DHCP Snooping enabled globally on Sw3. Ports are now either "trusted" (uplinks, allow DHCP server replies) or "untrusted" (access ports, drop DHCP offers). → "ip dhcp snooping vlan 102,202".'));
            }
            if (sub3 === 'vlan') {
              const vlanList = (x._[4]||'').replace(/\s/g,'');
              if ((vlanList === '102,202' || vlanList === '202,102') && !c.dhcpSnoopingVlan) {
                c.dhcpSnoopingVlan = true; this.updateScore();
                return createStdout(this.guide('DHCP Snooping activated for VLANs 102 and 202 only. Other VLANs are unaffected. → "ip dhcp snooping verify mac-address".'));
              }
            }
            if (sub3 === 'verify' && (x._[4]||'').toLowerCase() === 'mac-address' && !c.dhcpSnoopingMac) {
              c.dhcpSnoopingMac = true; this.updateScore();
              return createStdout(this.guide('MAC address verification enabled. The switch compares the DHCP payload source-MAC against the Ethernet frame src-MAC — mismatches are dropped, preventing DHCP packet-crafting attacks.'));
            }
          }
          return createStdout('');
        }

        return createStderr('% Invalid input detected');
      }

      // Interface config commands
      if (s.mode === 'config-if') {
        // ip access-group WWW_ACL in
        if (sub1 === 'access-group') {
          const aclName = (x._[2]||'').toUpperCase();
          const dir = (x._[3]||'').toLowerCase();
          if (dev === 'r1' && aclName === 'WWW_ACL' && dir === 'in' && s.currentIf === '0/1' && !c.accessGroup) {
            c.accessGroup = true; this.updateScore();
            return createStdout(this.guide('WWW_ACL applied inbound on R1 e0/1. Traffic entering from the internal network is filtered before R1 processes it — more efficient than outbound. → Verify with "sh ip access-lists".'));
          }
          return createStdout('');
        }
        return createStderr('% Invalid input detected');
      }

      return createStderr('% Invalid input detected');
    },

    iosPermit(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-ext-nacl') return createStderr('% Must be in ACL configuration mode — type "ip access-list extended WWW_ACL" first');
      const c = this[dev + 'Completion'];
      const proto = (x._[1]||'').toLowerCase();

      // permit tcp 10.101.1.0 0.0.0.255 any eq www
      if (proto === 'tcp' && x._[2] === '10.101.1.0' && x._[3] === '0.0.0.255' &&
          (x._[4]||'').toLowerCase() === 'any' && (x._[5]||'').toLowerCase() === 'eq' &&
          (x._[6]||'').toLowerCase() === 'www' && !c.acePermitHttp) {
        c.acePermitHttp = true; this.updateScore();
        return createStdout(this.guide('ACE 1: Permit HTTP from VLAN 202 (10.101.1.0/24) to any. This allows web traffic from the correct subnet. → "deny tcp any any eq www" to block HTTP from all other sources.'));
      }

      // permit ip any any
      if (proto === 'ip' && (x._[2]||'').toLowerCase() === 'any' && (x._[3]||'').toLowerCase() === 'any' && !c.acePermitAll) {
        c.acePermitAll = true; this.updateScore();
        return createStdout(this.guide('ACE 4: Permit all other IP traffic. This explicit permit-all is required — extended ACLs have an implicit deny-all at the end that would otherwise block all unmatched traffic. → "exit" then apply to interface.'));
      }

      return createStdout('');
    },

    iosDeny(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-ext-nacl') return createStderr('% Must be in ACL configuration mode — type "ip access-list extended WWW_ACL" first');
      const c = this[dev + 'Completion'];
      const proto = (x._[1]||'').toLowerCase();

      // deny tcp any any eq www
      if (proto === 'tcp' && (x._[2]||'').toLowerCase() === 'any' && (x._[3]||'').toLowerCase() === 'any' &&
          (x._[4]||'').toLowerCase() === 'eq' && (x._[5]||'').toLowerCase() === 'www' && !c.aceDenyHttp) {
        c.aceDenyHttp = true; this.updateScore();
        return createStdout(this.guide('ACE 2: Deny HTTP from all other sources. Without this ACE, other subnets could also browse the web since the permit-all ACE at the end would allow it. → "deny tcp host 10.101.0.2 any eq telnet".'));
      }

      // deny tcp host 10.101.0.2 any eq telnet
      if (proto === 'tcp' && (x._[2]||'').toLowerCase() === 'host' && x._[3] === '10.101.0.2' &&
          (x._[4]||'').toLowerCase() === 'any' && (x._[5]||'').toLowerCase() === 'eq' &&
          (x._[6]||'').toLowerCase() === 'telnet' && !c.aceDenyTelnet) {
        c.aceDenyTelnet = true; this.updateScore();
        return createStdout(this.guide('ACE 3: Deny Telnet from PC1 (10.101.0.2) only. "host" = /32 mask — matches exactly one IP. This blocks PC1\'s Telnet sessions to any destination. → "permit ip any any".'));
      }

      return createStdout('');
    },

    iosUsername(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      const user    = (x._[1]||'').toLowerCase();
      const priv    = String(x._[3]||'');
      const algType = (x._[5]||'').toLowerCase();
      const pwd     = String(x._[7]||'');
      if (dev === 'sw2' && user === 'admingroup' && priv === '15' && algType === 'scrypt' && pwd === 'BumBL3d' && !c.username) {
        c.username = true; this.updateScore();
        return createStdout(this.guide('User "AdminGroup" (priv 15) created with Scrypt-hashed password. "algorithm-type scrypt" requires "secret" (not "password") — Scrypt is a memory-hard KDF resistant to GPU brute-force. → "line vty 0 4".'));
      }
      return createStdout('');
    },

    iosLine(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');
      const c = this[dev + 'Completion'];
      if (dev === 'sw2' && (x._[1]||'').toLowerCase() === 'vty') {
        s.mode = 'config-line';
        if (!c.lineVty) { c.lineVty = true; this.updateScore(); }
        return createStdout(this.guide('VTY 0-4 line configuration entered. → "transport input telnet" then "login local".'));
      }
      return createStdout('');
    },

    iosLogin(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode — type "line vty 0 4" first');
      const c = this[dev + 'Completion'];
      if (dev === 'sw2' && (x._[1]||'').toLowerCase() === 'local' && !c.loginLocal) {
        c.loginLocal = true; this.updateScore();
        return createStdout(this.guide('VTY lines use local authentication. Telnet connections will prompt for the AdminGroup credentials. → Save the configuration.'));
      }
      return createStdout('');
    },

    iosTransport(dev, x) {
      const s = this[dev];
      if (s.mode !== 'config-line') return createStderr('% Must be in line configuration mode');
      const c = this[dev + 'Completion'];
      const sub2 = (x._[2]||'').toLowerCase();
      if (dev === 'sw2' && (x._[1]||'').toLowerCase() === 'input' && sub2 === 'telnet' && !c.transportTelnet) {
        c.transportTelnet = true; this.updateScore();
        return createStdout(this.guide('VTY lines restricted to Telnet only. SSH is not configured — Telnet is appropriate here per the task requirement. → "login local".'));
      }
      return createStdout('');
    },

    iosShow(dev, x) {
      const sub1=(x._[1]||'').toLowerCase(), sub2=(x._[2]||'').toLowerCase();

      // show ip access-lists / show access-lists
      if ((sub1 === 'ip' && sub2 === 'access-lists') || sub1 === 'access-lists') {
        const c = this.r1Completion;
        if (!c.aclCreated) return createStdout('(No IP access lists defined)');
        let out = 'Extended IP access list WWW_ACL<br>';
        let seq = 10;
        if (c.acePermitHttp) { out += `&nbsp;&nbsp;${seq} permit tcp 10.101.1.0 0.0.0.255 any eq www<br>`; seq += 10; }
        if (c.aceDenyHttp)   { out += `&nbsp;&nbsp;${seq} deny tcp any any eq www<br>`; seq += 10; }
        if (c.aceDenyTelnet) { out += `&nbsp;&nbsp;${seq} deny tcp host 10.101.0.2 any eq telnet (12 match(es))<br>`; seq += 10; }
        if (c.acePermitAll)  { out += `&nbsp;&nbsp;${seq} permit ip any any (25 match(es))<br>`; seq += 10; }
        return createStdout(out + (c.accessGroup
          ? this.guide('ACL active — applied inbound on R1 e0/1. Matches confirm traffic is being filtered.')
          : this.guide('→ Apply ACL: "interface e0/1" then "ip access-group WWW_ACL in".')
        ));
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(dev, x) {
      if (this[dev].mode !== 'exec') return createStderr('% Must be in exec mode — type "end" first');
      const c = this[dev + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${this.devLabel(dev)} saved. ` + (this.saveDone ? '✓ All devices saved — simulation complete!' : '→ Save remaining devices.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #sw2_terminal, #sw3_terminal { overflow: hidden !important; }
</style>

